export const GET_USER_SUCCESS = "get/user/success";
export const GET_USER_REQUEST = "get/user/request";
export const USER_SIGNED_OUT = "delete/user/session/success";

export const SET_USER_INFO_REQUEST = "set/user/info/request";
export const SET_USER_INFO_SUCCESS = "set/user/info/success";
export const SET_USER_INFO_FAILURE = "set/user/info/failure";

export const RESET_PASSWORD_REQUEST = "reset/password/request";
export const RESET_PASSWORD_SUCCESS = "reset/password/success";
export const RESET_PASSWORD_FAILURE = "reset/password/failure";

export const UPDATE_FORGOTTEN_PASSWORD_REQUEST = "update/forgotten/pwd/request";
export const UPDATE_FORGOTTEN_PASSWORD_SUCCESS = "update/forgotten/pwd/success";
export const UPDATE_FORGOTTEN_PASSWORD_FAILURE = "update/forgotten/pwd/failure";

export const CREATE_USER_REQUEST = "create/user/request";
export const CREATE_USER_SUCCESS = "create/user/success";
export const CREATE_USER_FAILURE = "create/user/failure";

export const EMAIL_EXISTS_REQUEST = "email/exists/request";
export const EMAIL_EXISTS_SUCCESS = "email/exists/success";
export const EMAIL_EXISTS_FAILURE = "email/exists/failure";

export const MERGE_ACCOUNT_REQUEST = "merge/account/request";
export const MERGE_ACCOUNT_SUCCESS = "merge/account/success";
export const MERGE_ACCOUNT_FAILURE = "merge/account/failure";

export const RESEND_ACTIVATION_EMAIL_REQUEST =
  "resend/activation/email/request";
export const RESEND_ACTIVATION_EMAIL_SUCCESS =
  "resend/activation/email/success";
export const RESEND_ACTIVATION_EMAIL_FAILURE =
  "resend/activation/email/failure";

export const REQUEST_EMAIL_VERIFICATION_REQUEST =
  "request/email/verification/request";
export const REQUEST_EMAIL_VERIFICATION_SUCCESS =
  "request/email/verification/success";
export const REQUEST_EMAIL_VERIFICATION_FAILURE =
  "request/email/verification/failure";
